import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../security/AuthLogin';
import FullScreenSpinner from '../components/FullScreenSpinner';

const VerificationPage: React.FC = () => {
  const { isAuthenticated, isLoading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    // Cuando la verificación esté lista y el usuario esté autenticado, redirigir al dashboard
    if (!isLoading) {
      if (isAuthenticated) {
        navigate('/', { replace: true }); // Redirige al dashboard
      } else {
        navigate('/login', { replace: true }); // Si no está autenticado, redirige al login
      }
    }
  }, [isLoading, isAuthenticated, navigate]);

  return <FullScreenSpinner />;
};

export default VerificationPage;
